import React, { forwardRef } from 'react';
import { css, cx } from '@linaria/atomic';
import type { CommonHTMLAttributes } from '@frontend/types';
import { Button } from '../../button/button.component';
import type { ButtonProps } from '../../button/button.type';
import { Heading, type HeadingProps } from '../../heading/heading.component';
import { useDrawerContext } from '../context';

// Heading's base style already sets `margin: 0`, so no override is needed here.
const Title = (props: HeadingProps) => <Heading level={2} {...props} />;

const Close = (props: Omit<ButtonProps, 'variant'>) => {
  const { close } = useDrawerContext();
  return <Button variant='secondary' iconName={props?.iconName ?? 'x'} onClick={close} {...props} />;
};

const drawerHeaderStyle = css`
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  position: relative;
`;

export const DrawerHeaderOptional = forwardRef<HTMLElement, CommonHTMLAttributes & { children: React.ReactNode }>(
  ({ children, className, ...rest }, ref) => {
    return (
      <header ref={ref} className={cx(drawerHeaderStyle, className)} {...rest}>
        {children}
      </header>
    );
  }
);

DrawerHeaderOptional.displayName = 'DrawerHeader';

const DrawerHeaderNamespace = Object.assign(DrawerHeaderOptional, {
  Title,
  Close,
});

export { DrawerHeaderNamespace as DrawerHeader };
